export const actionTypes = {
    add: 'add',
    remove: 'remove',
    replace: 'replace'
};

export default actionTypes;
